export type LoginFieldErrors = { email?: string; password?: string };

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function loginFieldErrors(email: string, password: string): LoginFieldErrors {
	const errors: LoginFieldErrors = {};
	const trimmed = email.trim();
	if (!trimmed) errors.email = "Email is required.";
	else if (!EMAIL.test(trimmed)) errors.email = "Enter a valid email.";
	if (!password) errors.password = "Password is required.";
	return errors;
}
